// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CARDS GRID */

.e2e_cards_grid{

  display:grid;

  grid-template-columns:
  repeat(4,1fr);

  gap:18px;

  margin-bottom:20px;
}

.e2e_single_card{

  background:white;

  border-radius:18px;

  padding:18px;

  min-height:120px;

  box-shadow:
  0 4px 14px rgba(0,0,0,0.05);

  transition:all 0.3s ease;

  overflow:hidden;

  position:relative;

  width:100%;
  border:2px solid transparent;
  text-align:left;
  font:inherit;
  cursor:pointer;
}

/* HOVER */

.e2e_single_card:hover{

  transform:translateY(-5px);

  box-shadow:
  0 10px 24px rgba(0,0,0,0.08);
}

/* TOP SECTION */

.e2e_card_top{

  display:flex;

  justify-content:space-between;

  align-items:flex-start;
}

/* TITLE */

.e2e_card_top p{

  font-size:14px;

  color:#7b8199;

  font-weight:500;
}

/* COUNT */

.e2e_card_top h2{

  margin-top:8px;

  font-size:28px;

  font-weight:800;

  color:#1f2940;
}

/* ICON */

.e2e_card_icon{

  width:52px;
  height:52px;

  border-radius:16px;

  display:flex;

  justify-content:center;
  align-items:center;

  font-size:22px;

  color:white;

  background:
  linear-gradient(
    to right,
    #7c4dff,
    #abe6ee
  );

  box-shadow:
  0 8px 20px rgba(124,77,255,0.25);
}

/* BOTTOM */

.e2e_card_bottom{

  margin-top:18px;
}

/* GROWTH */

.e2e_card_bottom span{

  font-size:13px;

  font-weight:700;

  color:#00b894;

  background:#ebfff8;

  padding:6px 10px;

  border-radius:8px;
}

/* RESPONSIVE */

@media screen and (max-width:1200px){

  .e2e_cards_grid{

    grid-template-columns:
    repeat(2,1fr);
  }
}

@media screen and (max-width:768px){

  .e2e_cards_grid{

    grid-template-columns:1fr;
  }

  .e2e_single_card{

    min-height:110px;
  }
}

.e2e_single_card:focus-visible{
  outline:3px solid rgba(37,99,235,.24);
  outline-offset:3px;
}

.e2e_single_card.e2e_single_card_active{
  border-color:#2563eb;
  transform:scale(1.025);
  box-shadow:0 12px 28px rgba(37,99,235,.2);
}

.e2e_single_card.e2e_single_card_active:hover{
  transform:scale(1.025) translateY(-3px);
}

.e2e_single_card{
  border-radius:14px;
  box-shadow:0 3px 14px rgba(16,24,40,.06);
}
.e2e_single_card.e2e_single_card_active{
  border-color:#6c63ff;
  transform:none;
  box-shadow:0 8px 24px rgba(79,70,229,.12);
}
.e2e_single_card.e2e_single_card_active:hover{transform:translateY(-3px)}
.e2e_card_top p{color:#1d2939;font-weight:700}
.e2e_card_top h2{color:#0b1538}
.e2e_card_icon{
  border-radius:13px;
  background:linear-gradient(135deg,#5b21f4,#4f86f7);
}

.e2e_card_category_counts{display:flex;flex-wrap:wrap;gap:6px;width:100%}
.e2e_card_category_counts span{display:inline-flex;align-items:center;gap:5px;padding:5px 7px;border-radius:8px;background:#f2efff;color:#5b35f5;font-size:10px;font-weight:700}
.e2e_card_category_counts span.benchsales{background:#e8f8f5;color:#087f72}
.e2e_card_category_counts i{width:7px;height:7px;border-radius:50%;background:#6d4aff}
.e2e_card_category_counts .benchsales i{background:#15a594}
.e2e_card_category_counts b{margin-left:2px;color:#1d2939;font-size:12px}`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard/cards.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;;EAEE,YAAY;;EAEZ;eACa;;EAEb,QAAQ;;EAER,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;;EAEhB,kBAAkB;;EAElB,YAAY;;EAEZ,gBAAgB;;EAEhB;6BAC2B;;EAE3B,wBAAwB;;EAExB,eAAe;;EAEf,iBAAiB;;EAEjB,UAAU;EACV,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA,UAAU;;AAEV;;EAEE,0BAA0B;;EAE1B;8BAC4B;AAC9B;;AAEA,gBAAgB;;AAEhB;;EAEE,YAAY;;EAEZ,6BAA6B;;EAE7B,sBAAsB;AACxB;;AAEA,UAAU;;AAEV;;EAEE,cAAc;;EAEd,aAAa;;EAEb,eAAe;AACjB;;AAEA,UAAU;;AAEV;;EAEE,cAAc;;EAEd,cAAc;;EAEd,eAAe;;EAEf,aAAa;AACf;;AAEA,SAAS;;AAET;;EAEE,UAAU;EACV,WAAW;;EAEX,kBAAkB;;EAElB,YAAY;;EAEZ,sBAAsB;EACtB,kBAAkB;;EAElB,cAAc;;EAEd,WAAW;;EAEX;;;;;GAKC;;EAED;kCACgC;AAClC;;AAEA,WAAW;;AAEX;;EAEE,eAAe;AACjB;;AAEA,WAAW;;AAEX;;EAEE,cAAc;;EAEd,eAAe;;EAEf,aAAa;;EAEb,kBAAkB;;EAElB,gBAAgB;;EAEhB,iBAAiB;AACnB;;AAEA,eAAe;;AAEf;;EAEE;;IAEE;iBACa;EACf;AACF;;AAEA;;EAEE;;IAEE,yBAAyB;EAC3B;;EAEA;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,yCAAyC;AAC3C;AACA,8CAA8C,0BAA0B;AACxE,gBAAgB,aAAa,CAAC,eAAe;AAC7C,iBAAiB,aAAa;AAC9B;EACE,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA,0BAA0B,YAAY,CAAC,cAAc,CAAC,OAAO,CAAC,UAAU;AACxE,+BAA+B,mBAAmB,CAAC,kBAAkB,CAAC,OAAO,CAAC,eAAe,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe;AAC/K,0CAA0C,kBAAkB,CAAC,aAAa;AAC1E,4BAA4B,SAAS,CAAC,UAAU,CAAC,iBAAiB,CAAC,kBAAkB;AACrF,wCAAwC,kBAAkB;AAC1D,4BAA4B,eAAe,CAAC,aAAa,CAAC,cAAc","sourcesContent":["/* CARDS GRID */\n\n.e2e_cards_grid{\n\n  display:grid;\n\n  grid-template-columns:\n  repeat(4,1fr);\n\n  gap:18px;\n\n  margin-bottom:20px;\n}\n\n.e2e_single_card{\n\n  background:white;\n\n  border-radius:18px;\n\n  padding:18px;\n\n  min-height:120px;\n\n  box-shadow:\n  0 4px 14px rgba(0,0,0,0.05);\n\n  transition:all 0.3s ease;\n\n  overflow:hidden;\n\n  position:relative;\n\n  width:100%;\n  border:2px solid transparent;\n  text-align:left;\n  font:inherit;\n  cursor:pointer;\n}\n\n/* HOVER */\n\n.e2e_single_card:hover{\n\n  transform:translateY(-5px);\n\n  box-shadow:\n  0 10px 24px rgba(0,0,0,0.08);\n}\n\n/* TOP SECTION */\n\n.e2e_card_top{\n\n  display:flex;\n\n  justify-content:space-between;\n\n  align-items:flex-start;\n}\n\n/* TITLE */\n\n.e2e_card_top p{\n\n  font-size:14px;\n\n  color:#7b8199;\n\n  font-weight:500;\n}\n\n/* COUNT */\n\n.e2e_card_top h2{\n\n  margin-top:8px;\n\n  font-size:28px;\n\n  font-weight:800;\n\n  color:#1f2940;\n}\n\n/* ICON */\n\n.e2e_card_icon{\n\n  width:52px;\n  height:52px;\n\n  border-radius:16px;\n\n  display:flex;\n\n  justify-content:center;\n  align-items:center;\n\n  font-size:22px;\n\n  color:white;\n\n  background:\n  linear-gradient(\n    to right,\n    #7c4dff,\n    #abe6ee\n  );\n\n  box-shadow:\n  0 8px 20px rgba(124,77,255,0.25);\n}\n\n/* BOTTOM */\n\n.e2e_card_bottom{\n\n  margin-top:18px;\n}\n\n/* GROWTH */\n\n.e2e_card_bottom span{\n\n  font-size:13px;\n\n  font-weight:700;\n\n  color:#00b894;\n\n  background:#ebfff8;\n\n  padding:6px 10px;\n\n  border-radius:8px;\n}\n\n/* RESPONSIVE */\n\n@media screen and (max-width:1200px){\n\n  .e2e_cards_grid{\n\n    grid-template-columns:\n    repeat(2,1fr);\n  }\n}\n\n@media screen and (max-width:768px){\n\n  .e2e_cards_grid{\n\n    grid-template-columns:1fr;\n  }\n\n  .e2e_single_card{\n\n    min-height:110px;\n  }\n}\n\n.e2e_single_card:focus-visible{\n  outline:3px solid rgba(37,99,235,.24);\n  outline-offset:3px;\n}\n\n.e2e_single_card.e2e_single_card_active{\n  border-color:#2563eb;\n  transform:scale(1.025);\n  box-shadow:0 12px 28px rgba(37,99,235,.2);\n}\n\n.e2e_single_card.e2e_single_card_active:hover{\n  transform:scale(1.025) translateY(-3px);\n}\n\n.e2e_single_card{\n  border-radius:14px;\n  box-shadow:0 3px 14px rgba(16,24,40,.06);\n}\n.e2e_single_card.e2e_single_card_active{\n  border-color:#6c63ff;\n  transform:none;\n  box-shadow:0 8px 24px rgba(79,70,229,.12);\n}\n.e2e_single_card.e2e_single_card_active:hover{transform:translateY(-3px)}\n.e2e_card_top p{color:#1d2939;font-weight:700}\n.e2e_card_top h2{color:#0b1538}\n.e2e_card_icon{\n  border-radius:13px;\n  background:linear-gradient(135deg,#5b21f4,#4f86f7);\n}\n\n.e2e_card_category_counts{display:flex;flex-wrap:wrap;gap:6px;width:100%}\n.e2e_card_category_counts span{display:inline-flex;align-items:center;gap:5px;padding:5px 7px;border-radius:8px;background:#f2efff;color:#5b35f5;font-size:10px;font-weight:700}\n.e2e_card_category_counts span.benchsales{background:#e8f8f5;color:#087f72}\n.e2e_card_category_counts i{width:7px;height:7px;border-radius:50%;background:#6d4aff}\n.e2e_card_category_counts .benchsales i{background:#15a594}\n.e2e_card_category_counts b{margin-left:2px;color:#1d2939;font-size:12px}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
